import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'recentSearchCleanFormat'
})
export class RecentSearchCleanFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value
      .replace(/[^\p{L}\p{N}\s.,;:¡!¿?()\-"]/gu, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
